import { createFileRoute } from "@tanstack/react-router";
import { ArticleLayout } from "@/components/article-layout";
import { getArticle } from "@/content/articles";
import { abs, articleHead } from "@/content/seo";
import ogSocial from "@/assets/og-sylwia-sitkowska.jpg";

const article = getArticle("samotnosc-lidera");

export const Route = createFileRoute("/samotnosc-lidera")({
  head: () => articleHead(article, abs(ogSocial)),
  component: () => <ArticleLayout article={article} />,
});
